import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { Role } from 'src/app/model/admin/role';

@Injectable({
  providedIn: 'root',
})
export class RoleTableService extends BaseTableService<Role> {
  constructor() {
    super();
  }
}
